import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { CTAButton } from '../ui/CTAButton';
export const BottomCTASection = () => {
  return <div className="space-y-12 py-8 pb-20" data-id="element-149">
      <FadeIn data-id="element-150">
        <div className="bg-amber-950/30 border border-amber-900/50 rounded-2xl p-6 sm:p-8 text-center" data-id="element-151">
          <h3 className="text-xl font-bold text-amber-500 mb-4 flex items-center justify-center gap-2" data-id="element-152">
            <span data-id="element-153">⏰</span> URGENCIA REAL
          </h3>
          <p className="text-lg text-slate-300" data-id="element-154">
            Cada noche que pasa sin el protocolo es una noche más de ácido
            quemando tu esófago. El daño acumulativo del reflujo no tratado no
            espera. Tu esófago tampoco.
          </p>
        </div>
      </FadeIn>

      <FadeIn data-id="element-155">
        <div className="bg-slate-900 border border-slate-700 rounded-3xl p-8 sm:p-12 text-center shadow-2xl relative overflow-hidden" data-id="element-156">
          <div className="absolute top-0 left-0 w-full h-2 bg-green-500" data-id="element-157"></div>

          <h2 className="text-2xl font-bold text-white mb-8" data-id="element-158">Tu Inversión:</h2>

          <div className="flex flex-col items-center justify-center gap-2 mb-8" data-id="element-159">
            <div className="text-slate-400 text-xl line-through" data-id="element-160">
              Valor Total: $332 USD
            </div>
            <div className="text-4xl sm:text-5xl font-black text-white bg-green-900/30 px-6 py-4 rounded-2xl border border-green-800/50" data-id="element-161">
              <span className="text-amber-500 mr-3" data-id="element-162">🔥</span>
              PRECIO DE LANZAMIENTO:{' '}
              <span className="text-green-400" data-id="element-163">$6.39 USD</span>
            </div>
          </div>

          <ul className="flex flex-col sm:flex-row justify-center gap-4 sm:gap-8 text-slate-300 font-medium mb-10" data-id="element-164">
            <li className="flex items-center justify-center gap-2" data-id="element-165">
              <span data-id="element-166">📥</span> Descarga inmediata
            </li>
            <li className="flex items-center justify-center gap-2" data-id="element-167">
              <span data-id="element-168">♾️</span> Acceso de por vida
            </li>
            <li className="flex items-center justify-center gap-2" data-id="element-169">
              <span data-id="element-170">🛡️</span> Garantía de 7 noches
            </li>
          </ul>

          <CTAButton text="✅ SÍ, QUIERO MIS 7 NOCHES SIN ARDOR — $6.39 USD →" className="mb-6" data-id="element-171" />

          <div className="flex flex-wrap justify-center gap-4 sm:gap-6 text-sm text-slate-400 mt-6" data-id="element-172">
            <span className="flex items-center gap-1" data-id="element-173">🔒 Pago 100% Seguro</span>
            <span className="hidden sm:inline" data-id="element-174">•</span>
            <span className="flex items-center gap-1" data-id="element-175">
              📥 Descarga Inmediata
            </span>
            <span className="hidden sm:inline" data-id="element-176">•</span>
            <span className="flex items-center gap-1" data-id="element-177">
              🛡️ Garantía Total de 7 Días
            </span>
          </div>
        </div>
      </FadeIn>

      <FadeIn data-id="element-178">
        <div className="pt-8" data-id="element-179">
          <h3 className="text-2xl font-bold text-white text-center mb-8" data-id="element-180">
            Lo que dicen nuestros clientes
          </h3>
          <div className="rounded-2xl overflow-hidden border border-slate-800 shadow-xl" data-id="element-181">
            <img src="https://cdn.magicpatterns.com/uploads/cgzvWDettaMGz4y9D3N6AE/ig_comments_noche_sin_reflujo.png" alt="Comentarios de clientes en Instagram" className="w-full h-auto" data-id="element-182" />
          </div>
        </div>
      </FadeIn>

      <FadeIn data-id="element-183">
        <div className="pt-8" data-id="element-184">
          <CTAButton text="✅ SÍ, QUIERO MIS 7 NOCHES SIN ARDOR — $6.39 USD →" data-id="element-185" />
        </div>
      </FadeIn>
    </div>;
};